import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  TextField,
  Select,
  MenuItem,
  FormLabel,
  Input
} from '@mui/material';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { patchApi, getApi } from 'views/services/api';
import { toast } from 'react-toastify';
import VisibilityIcon from '@mui/icons-material/Visibility';

const EditCustomerModal = ({ open, handleClose, data }) => {
    const customer=data?.customerDetails || {};
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      phoneNumber: customer?.phoneNumber || '',
      firstName: customer?.firstName || '',
      lastName: customer?.lastName || '',
      email: customer?.email || '',
      idCardType: customer?.idCardType || 'default',
      idcardNumber: customer?.idcardNumber || '',
      idFile: customer?.idFile || null,
      address: customer?.address || ''
    },
    validationSchema: yup.object({
      phoneNumber: yup.string().required('Phone number is required'),
      firstName: yup.string().required('First name is required')
    }),
    onSubmit: async (values) => {
      try {
        await patchApi(`api/customer/doreservation/${data?._id}`, values);
        toast.success('Customer updated successfully');
        handleClose(true);
      } catch (err) {
        toast.error('Failed to update customer');
      }
    }
  });

  
const handlePhoneChange = async (e) => {
  const phone = e.target.value.replace(/\D/g, '').slice(0, 10);

  // 1️⃣ Always update phone
  formik.setFieldValue('phoneNumber', phone);

  // 2️⃣ CLEAR previous customer data immediately
  formik.setValues({
    phoneNumber: phone,
    firstName: '',
    lastName: '',
    email: '',
    idCardType: 'default',
    idcardNumber: '',
    idFile: null,
    address: ''
  });

  // 3️⃣ Only fetch if valid phone
  if (phone.length !== 10) return;

  try {
    const res = await getApi(
      `api/customer/view/${phone}?hotelId=${customer?.hotelId}`
    );

    const foundCustomer = res?.data?.customerData?.[0];

    if (foundCustomer) {
      formik.setValues({
        phoneNumber: foundCustomer.phoneNumber || phone,
        firstName: foundCustomer.firstName || '',
        lastName: foundCustomer.lastName || '',
        email: foundCustomer.email || '',
        idCardType: foundCustomer.idCardType || 'default',
        idcardNumber: foundCustomer.idcardNumber || '',
        idFile: foundCustomer.idFile || null,
        address: foundCustomer.address || ''
      });

      toast.info('Existing customer loaded');
    }
  } catch (err) {
    console.error(err);
  }
};


  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <DialogTitle>Edit Customer Details</DialogTitle>

      <DialogContent dividers>
        <Grid container spacing={2}>
          {/* Phone */}
          <Grid item xs={12} md={6}>
            <FormLabel>Phone Number</FormLabel>
            <TextField
              fullWidth
              size="small"
              value={formik.values.phoneNumber}
              onChange={handlePhoneChange}
              placeholder="Enter 10 digit phone"
            />
          </Grid>

          {/* First Name */}
          <Grid item xs={12} md={6}>
            <FormLabel>First Name</FormLabel>
            <TextField
              fullWidth
              size="small"
              name="firstName"
              value={formik.values.firstName}
              onChange={formik.handleChange}
            />
          </Grid>

          {/* Last Name */}
          <Grid item xs={12} md={6}>
            <FormLabel>Last Name</FormLabel>
            <TextField
              fullWidth
              size="small"
              name="lastName"
              value={formik.values.lastName}
              onChange={formik.handleChange}
            />
          </Grid>

          {/* Email */}
          <Grid item xs={12} md={6}>
            <FormLabel>Email</FormLabel>
            <TextField
              fullWidth
              size="small"
              name="email"
              value={formik.values.email}
              onChange={formik.handleChange}
            />
          </Grid>

          {/* ID Type */}
          <Grid item xs={12} md={6}>
            <FormLabel>ID Card Type</FormLabel>
            <Select
              fullWidth
              size="small"
              name="idCardType"
              value={formik.values.idCardType}
              onChange={formik.handleChange}
            >
              <MenuItem value="default" disabled>Select</MenuItem>
              <MenuItem value="Aadharcard">Aadhar</MenuItem>
              <MenuItem value="VoterIdCard">Voter ID</MenuItem>
              <MenuItem value="PanCard">PAN</MenuItem>
              <MenuItem value="DrivingLicense">Driving License</MenuItem>
              <MenuItem value="passport">Passport</MenuItem>
            </Select>
          </Grid>

          {/* ID Number */}
          <Grid item xs={12} md={6}>
            <FormLabel>ID Card Number</FormLabel>
            <TextField
              fullWidth
              size="small"
              name="idcardNumber"
              value={formik.values.idcardNumber}
              onChange={formik.handleChange}
            />
          </Grid>

          {/* Address */}
          <Grid item xs={12}>
            <FormLabel>Address</FormLabel>
            <TextField
              fullWidth
              size="small"
              name="address"
              value={formik.values.address}
              onChange={formik.handleChange}
            />
          </Grid>

          <Grid item xs={12}>
            <FormLabel>ID Proof</FormLabel>
            {formik.values.idFile ? (
              <Button
                startIcon={<VisibilityIcon />}
                href={formik.values.idFile}
                target="_blank"
              >
                View ID
              </Button>
            ) : (
              <Input
                type="file"
                onChange={(e) =>
                  formik.setFieldValue('idFile', e.currentTarget.files[0])
                }
              />
            )}
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button onClick={() => handleClose(false)}>Cancel</Button>
        <Button variant="contained" onClick={formik.handleSubmit}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditCustomerModal;
